import TokyoTechLogo from "../../assets/tokyo-tach-logo.png";
import KyotoUniLogo from "../../assets/kyoto-uni-logo.png";
import TsinghuaUniLogo from "../../assets/Tsinghua-Uni-logo.png";
import YangzhouUniLogo from "../../assets/Yangzhou-Uni-logo.png";
import NCARLogo from "../../assets/NCAR-logo.jpeg";

export const CollaborationDetails = [
  {
    title: TokyoTechLogo,
    url: "https://www.titech.ac.jp/english",
  },
  {
    title: KyotoUniLogo,
    url: "https://www.kyoto-u.ac.jp/en",
  },
  {
    title: TsinghuaUniLogo,
    url: "https://www.tsinghua.edu.cn/en/",
  },
  {
    title: YangzhouUniLogo,
    url: "https://english.yzu.edu.cn/",
  },
  {
    title: NCARLogo,
    url: "https://ncar.ucar.edu/",
  },
];
